export const CALUCLATOR_LINK_BY_LANG_ID = {
  2: '/en/calculator',
  1: '/calculator',
  11: '/cn/calculator',
  7: '/es/calculator',
  default: '/calculator',
};
